import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { ToastService } from '../../../components/toast/toast.service';
import { AuthenticationService } from '../../services/authentication.service';
import { LoaderService } from 'src/app/core/components/loader/loader.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';

@Component({
    selector: 'app-login',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        InputTextModule,
        ButtonModule,
        PasswordModule,
        FormsModule,
        DividerModule,
    ],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  public loginForm!: FormGroup;

  public passwordVisible: boolean = false;

  public emailTouched = false;
  loadingState$: Observable<boolean> = this.loaderService.localLoaderState;
  public currentUser: Observable<any>;
  private readonly currentUserSubject: BehaviorSubject<any>;

  constructor(
    public fb: FormBuilder,
    public authenticationService: AuthenticationService,
    public router: Router,
    public toastService: ToastService,
    private readonly loaderService: LoaderService,
    public cdr: ChangeDetectorRef,
  ) {
    let currentUserJson = localStorage.getItem('currentUser');
    let parsedUser: any = {};

    try {
      parsedUser = currentUserJson
        ? JSON.parse(currentUserJson)
        : ({} as any);
    } catch (e) {
      console.warn('Failed to parse stored user data:', e);
      localStorage.removeItem('currentUser');
    }

    this.currentUserSubject = new BehaviorSubject<any>(parsedUser);
    this.currentUser = this.currentUserSubject.asObservable();

    this.initForm();
  }

  /**
   * Initializes the login form
   */
  private initForm(): void {
    this.loginForm = this.fb.group({
      email: [null],
      password: [null, [Validators.required]],
    });
  }

  /**
   * Handles form submission
   */
  public onSubmit(): void {
    this.loaderService.showLocal();
    const { email, password } = this.loginForm.value;

    const payload = {
      Username: email,
      Password: password,
    };

    this.authenticationService
      .login(payload)
      .pipe()
      .subscribe({
        next: (response) => {
          this.authenticationService.saveUserData(response.data);
        },
        error: (error) => {
          this.loginForm.setErrors({ invalidLogin: true });
          this.loaderService.hideLocal();
        },
        complete: () => {
          this.router.navigate(['/']);
          this.loaderService.hideLocal();
        },
    });
  }

  /**
   * toggle Password Field Visibility
   */
  public togglePasswordVisibility(passwordId: number): void {
    this.passwordVisible = !this.passwordVisible;
  }

  public handleKeydown(event: KeyboardEvent, passwordId: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.togglePasswordVisibility(passwordId);
    }
  }

  public onBlurEmail(): void {
    this.emailTouched = true; // Mark email as touched manually on blur
  }

  /**
   *  Getters for the  form controls
   *    */

  get password() {
    return this.loginForm?.get('password');
  }

  get email() {
    return this.loginForm?.get('email');
  }
}
